import { useIntl } from 'react-intl';
import { t } from '../../../lang';
import HelperService from '../../../services/HelperService';
import TypesService from '../../../services/TypesService';
import IconAML from '../../IconAML/IconAML';
import InlineNotice from '../../InlineNotice';
import './AMLAddressHeader.scss';

const risksParams = {
	Low: { title: 'Low risk' },
	Medium: { title: 'Medium risk' },
	High: { title: 'High risk' },
	Outdated: { title: 'Outdated risk' },
	Unchecked: { title: 'Unchecked risk' },
	Unverified: { title: 'Unverified' },
};

const BlockchainsById = TypesService.BlockchainsById;

const AMLAddressHeader = ({ percent, isActualAML = false, lastCheckDate, blockchainName, isLoading }) => {
	const intl = useIntl();
	const { risk, riskStatus } = HelperService.getAmlRiskByText(
		percent,
		isActualAML,
		Object.values(BlockchainsById).find(i => i.network === blockchainName)?.network,
		false,
		lastCheckDate
	);

	const formatLastCheckDate = value => {
		if (!value) return '';

		const date = new Date(value);

		if (Number.isNaN(date.getTime())) return '';

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');

		return `${year}-${month}-${day} ${hours}:${minutes}`;
	};

	return (
		<div className='AMLAddressHeader'>
			<div className='AMLAddressHeader_content'>
				<div className='AMLAddressHeader_content_icon'>
					<IconAML
						percent={percent}
						isActualAML={isActualAML}
						blockchainName={blockchainName}
						isLoading={isLoading}
						iconOnly
						checkDate={lastCheckDate}
						size={48}
					/>
				</div>
				<div className='AMLAddressHeader_content_info'>
					<p className='AMLAddressHeader_content_info_risk'>
						{isLoading
							? '----'
							: intl.formatMessage({ id: risksParams[risk].title }) + (risk !== 'Unverified' ? ` ${percent}%` : '')}
					</p>
					<p className='AMLAddressHeader_content_info_date'>
						{t('Last check')}: {formatLastCheckDate(lastCheckDate)}
					</p>
				</div>
			</div>

			{riskStatus.outdated && !isLoading && (
				<InlineNotice type='error' icon='EXCLAMATIONMARK_TRIANGLE_FILL'>
					<p className='AMLAddressHeader_error_text'>
						{t(
							'This AML result may no longer reflect the current state of the address.\nWe recommend running a new AML check to get up-to-date information.'
						)}
					</p>
				</InlineNotice>
			)}

			{riskStatus.Unverified && !isLoading && (
				<InlineNotice type='neutral' icon='INFO_CIRCLE'>
					<p className='AMLAddressHeader_error_text'>
						{t('No risk data available — this address has no recorded activity.')}
					</p>
				</InlineNotice>
			)}
		</div>
	);
};

export default AMLAddressHeader;
